import { ISectionMenuItem } from "components/PageTopNav";
import { useEnvContext, useWebStoreContext } from "contexts";
import { FeaturesFlags } from "helpers";
import { useAppDispatch } from "hooks";
import { usePopupsState } from "hooks/usePopupsState";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { offersApi } from "redux/apis";
import { onOpenPopUp, onOpenPopUpV2 } from "redux/slices";

interface IUseTutorialProps {
	sectionMenuData: ISectionMenuItem[];
}

export const useTutorial = ({ sectionMenuData }: IUseTutorialProps) => {
	const location = useLocation();
	const dispatch = useAppDispatch();
	const { isFeatureFlagEnabled, isFeatureFlagsReady } = useEnvContext();
	const { authToken, userTracker } = useWebStoreContext();
	const areFeatureFlagsReady = isFeatureFlagsReady(authToken?.value);
	const [tutorialFlag, setTutorialFlag] = useState<boolean>(false);
	const {
		isAnyDipOpen,
		isDipPriorityPending,
		isAnyPopupOpen,
		isMegaMenuOpen,
		isWelcomeFlowActive,
		IsInAppToWebDipChecking,
		IsFriendReferralAcceptInviteChecking
	} = usePopupsState();
	const { data: purchaseOffers } = offersApi.endpoints.getOffers.useQueryState({
		offerType: "singleItem",
		isAuthenticated: !!authToken?.value
	});

	useEffect(() => {
		const onSetHasSeenTutorial = () => {
			if (isFeatureFlagEnabled(FeaturesFlags.FTUE_V2)) {
				dispatch(
					onOpenPopUpV2({
						variant: "tutorial-v2",
						id: "tutorial-v2",
						replaceIfExists: true
					})
				);
			} else {
				dispatch(onOpenPopUp("tutorial"));
			}
			//await postUserMetadata({ key: "hasSeenTutorial", value: "true" });
		};
		if (
			!authToken?.value ||
			!areFeatureFlagsReady ||
			!userTracker ||
			userTracker?.metadata?.hasSeenTutorial === "true" ||
			userTracker?.isFirstLogin ||
			isAnyPopupOpen ||
			!sectionMenuData ||
			!purchaseOffers ||
			location.pathname !== "/shop" ||
			IsInAppToWebDipChecking ||
			IsFriendReferralAcceptInviteChecking ||
			isWelcomeFlowActive ||
			tutorialFlag ||
			isMegaMenuOpen ||
			isDipPriorityPending ||
			isAnyDipOpen
		) {
			return;
		}
		setTutorialFlag(true);
		onSetHasSeenTutorial();
	}, [
		authToken?.value,
		areFeatureFlagsReady,
		location,
		isAnyPopupOpen,
		sectionMenuData,
		purchaseOffers,
		userTracker,
		IsInAppToWebDipChecking,
		IsFriendReferralAcceptInviteChecking,
		isWelcomeFlowActive,
		isMegaMenuOpen,
		isDipPriorityPending,
		isAnyDipOpen
	]);
};
